import { css } from "@emotion/css"

const listItemStyles = {
  li: css`
    position: relative;

    &:not(:first-child)::before,
    &:not(:last-child)::after {
      position: absolute;
      display: block;
      width: calc(100% - 10px * 2);
      margin: 0 10px;
      pointer-events: none;
      content: "";
      border-top: 1px dashed #c4d1d9;
    }
    &:not(:first-child)::before {
      top: 0;
    }
    &:not(:last-child)::after {
      bottom: 0;
    }
    &:not(:first-child) {
      margin-top: -1px;
    }
  `,
  content: css`
    display: flex;
    align-items: center;

    height: 32px;
    padding: 0px 10px;

    font-size: 12px;
    font-weight: bold;
    color: #444444;
    outline-offset: -2px;
    li:first-child &,
    li:last-child & {
      height: 31px;
    }
  `,
  hover: css`
    background-color: #cbe8cc;
  `,
} as const

export default listItemStyles
